import { TagVariant } from '../shared/components/app-tag/app-tag.component';

export type HandoverLog = {
  id: string;
  activity: string;
  programId: string;
  programName: string;
  createdByName: string;
  createdById: string;
  createdDate: string | Date;
  dueDate: string | Date;
  notes: string;
  status: string;
  timezone: string;
  updatedDate: string | Date;
  updatedBy: string;
  tagLabel?: DueTagLabel;
  tagVariant?: TagVariant;
};

export type HandoverLogPost = {
  activity: string;
  program_id: string;
  notes: string;
  due_date: string;
  timezone: string;
  status: string;
  created_by: string;
  created_dttm: string;
};
export type HandoverLogDto = {
  id: number;
  activity: string;
  program_id: string;
  notes: string;
  due_date: string;
  timezone: string;
  status: string;
  created_by: string;
  updated_by: string;
  created_dttm: string;
  updated_dttm: string;
};

export enum DueTagLabel {
  Overdue = 'Overdue',
  DueSoon = 'Due soon',
}

export type HandoverLogPut = HandoverLogDto;
